/**
 * Created by DemonRay on 2019/3/27.
 */

const defaultEdgeTypes = {}

const defaultEdgeStyles = [
	{
		selector: 'edge',
		style: {
			'curve-style': 'bezier',
			'target-arrow-shape': 'triangle',
			'arrow-scale': 0.001,
			'width': 2,
			'control-point-step-size': 50
		}
	},
	{
		'selector': 'edge[lineType]',
		'style': {
			'curve-style': 'data(lineType)',
			"taxi-direction": "auto",
			// "taxi-turn": 90
		}
	},
	{
		selector: 'edge[renderWidth]',
		style: {
			'width': 'data(renderWidth)',
		}
	},
	{
		selector: 'edge[edgeLabel != ""]',
		style: {
			'label': 'data(edgeLabel)',
			'font-size': 16,
			'color': '#333333',
			'text-wrap': 'wrap',
			'text-max-width': 220,
			'text-margin-y': 'data(edgeLabelMarginY)',
			'text-background-color': '#ffffff',
			'text-background-opacity': 0.9,
			'text-background-padding': 3,
			'text-border-opacity': 0,
		}
	},
	{
		selector: 'edge[edgeLabelOrientation = "rotated"]',
		style: {
			'text-rotation': 'autorotate',
		}
	},
	{
		selector: 'edge[edgeLabelOrientation = "horizontal"]',
		style: {
			'text-rotation': 'none',
		}
	},
	{
		selector: 'edge[lineColor]',
		style: {
			'target-arrow-shape': 'triangle',
			'width': 2,
			'line-color': 'data(lineColor)',
			'source-arrow-color': 'data(lineColor)',
			'target-arrow-color': 'data(lineColor)',
			'mid-source-arrow-color': 'data(lineColor)',
			'mid-target-arrow-color': 'data(lineColor)'
		}
	},
	{
		selector: 'edge.legend-hover-match',
		style: {
			'overlay-color': '#0169D9',
			'overlay-padding': 12,
			'overlay-opacity': 0.28,
			'underlay-color': '#0169D9',
			'underlay-padding': 8,
			'underlay-opacity': 0.18,
			'line-outline-color': '#0169D9',
			'line-outline-width': 10,
			'line-outline-opacity': 0.22,
			'width': 6,
		}
	},
	{
		selector: 'edge.legend-hover-dim',
		style: {
			'opacity': 0.18,
			'text-opacity': 0.3,
		}
	},
	{
		selector: 'edge[lineColor]:active',
		style: {
			'overlay-color': '#0169D9',
			'overlay-padding': 3,
			'overlay-opacity': 0.25,
			'line-color': 'data(lineColor)',
			'source-arrow-color': 'data(lineColor)',
			'target-arrow-color': 'data(lineColor)',
			'mid-source-arrow-color': 'data(lineColor)',
			'mid-target-arrow-color': 'data(lineColor)'
		}
	},
	{
		selector: 'edge[lineColor]:selected',
		style: {
			'overlay-color': '#0169D9',
			'overlay-padding': 3,
			'overlay-opacity': 0.25,
			'line-color': 'data(lineColor)',
			'source-arrow-color': 'data(lineColor)',
			'target-arrow-color': 'data(lineColor)',
			'mid-source-arrow-color': 'data(lineColor)',
			'mid-target-arrow-color': 'data(lineColor)'
		}
	}
]

function getEdgeConf(type) {
	return defaultEdgeTypes.find(item => item.type === type)
}

export {defaultEdgeTypes, defaultEdgeStyles, getEdgeConf}
